import { schema } from 'normalizr';

export const voteMethodSchema = new schema.Entity('voteMethod');
